import { useEffect, useState } from "react";
import { Power } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { preconApi } from "@/estimating/lib/api";

/** Settings › Inbox — the ITB intake master switch (moved off the Inbox toolbar). */
export default function InboxSettingsPage() {
  const [s, setS] = useState(null);
  useEffect(() => { preconApi.getSettings().then(setS).catch(() => toast.error("Could not load Inbox settings")); }, []);
  if (!s) return <div className="p-6 text-sm text-muted-foreground">Loading…</div>;
  const toggle = async (v) => {
    setS({ ...s, intake_enabled: v });
    try { await preconApi.saveSettings({ intake_enabled: v }); toast.success(v ? "Intake on" : "Intake paused"); }
    catch (e) { setS({ ...s }); toast.error(e?.response?.data?.detail || "Not saved"); }
  };
  return (
    <div className="page-body space-y-6" data-testid="settings-inbox-pane">
      <section className="rounded-lg border border-border bg-card p-4 space-y-3">
        <h3 className="text-sm font-semibold text-foreground">ITB Inbox — intake</h3>
        <label className="flex items-center gap-3 text-sm">
          <Switch checked={!!s.intake_enabled} onCheckedChange={toggle} data-testid="settings-itb-intake-toggle" />
          <Power className="h-3.5 w-3.5 text-muted-foreground" />
          <span>Intake on <span className="text-xs text-muted-foreground">— master switch. Off, every forwarded or pasted email is refused and nothing is read.</span></span>
        </label>
        <p className="text-xs text-muted-foreground">
          Invitations forwarded to <span className="font-medium text-foreground">{s.forward_address}</span> land in the Inbox automatically; the list refreshes itself every 30 seconds.
        </p>
      </section>
    </div>
  );
}
